import { Formik, FieldArray } from "formik";
import Loader from "../../loader";
import StepsDots from "../../form/StepsDots";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import PdfOrImageUploader from "../../pdfImage uploader";
import { profileStep3Schema } from "../../../utils/schema";
import { setRegisterStep } from "../../../redux/features/find-a-job/reducers/authReducer";
import {
  fetchfreelancerProfile,
  profileStep3Submit,
} from "../../../redux/features/find-a-job/actions/authAction";
import {
  getProfile,
  setProfile,
  updateFreelancerFormData,
} from "../../../utils/pip";
import { useEffect, useState } from "react";

const ProfileSetupStep3 = () => {
  const dispatch = useDispatch();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const [savedData, setSavedData] = useState({});

  const splitList = (value) => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (!value) return [];
    return String(value)
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const parseArray = (value, fallback = []) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return fallback;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch {
        return trimmed
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }
    }
    return fallback;
  };

  const normalizeDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toISOString().slice(0, 10);
  };

  const emptyExperience = {
    job_title: "",
    company_name: "",
    job_description: "",
    start_date: "",
    end_date: "",
    currently_working: false,
    link: "",
  };

  const handleStep3 = (values) => {
    updateFreelancerFormData("profileStep3", {
      ...values,
      work_samples: (values.work_samples || []).map((f) =>
        f instanceof File
          ? { name: f.name, type: f.type, preview: URL.createObjectURL(f) }
          : f
      ),
    });

    const formData = new FormData();
    const portfolioLinks = values?.portfolio_links || [];
    const samplePortfolioLink = portfolioLinks.find((link) => link)?.trim() || "";
    formData.append("sample_portfolio_link", samplePortfolioLink);
    const sanitizedExperiences = (values?.experiences || []).map((exp) => {
      const endDate =
        exp.currently_working || !exp.end_date ? null : exp.end_date;
      return {
        ...exp,
        end_date: endDate,
      };
    });
    formData.append("experiences", JSON.stringify(sanitizedExperiences));

    (values?.work_samples || []).forEach((file) => {
      if (file instanceof File) {
        formData.append("projects", file);
      }
    });

    const callback = (response) => {
      if (!response?.success) return;
      dispatch(setRegisterStep("profileStep4"));
    };

    dispatch(profileStep3Submit({ payload: formData, callback }));
  };

  const refreshStep2FromProfile = async () => {
    const res = await dispatch(fetchfreelancerProfile());
    const data = res?.payload?.data;
    if (!data) return;
    const existing = getProfile("freelancer") || {};
    const merged = {
      ...existing,
      ...data,
      full_name:
        data.full_name ||
        existing.full_name ||
        `${data.first_name || ""} ${data.last_name || ""}`.trim(),
      first_name: data.first_name || existing.first_name || data.full_name || "",
      last_name: data.last_name || existing.last_name || "",
    };
    setProfile("freelancer", merged);
    const openTalent = merged.open_talent || {};
    updateFreelancerFormData("profileStep2", {
      primary_role: openTalent.primary_role || "",
      years_of_experience: openTalent.years_of_experience || "",
      key_skills: splitList(openTalent.key_skills || openTalent.skills),
      tools: splitList(openTalent.tools || openTalent.tools_software_used),
      availability: openTalent.availability || "",
      hourly_rate: openTalent.hourly_rate || "",
      preferred_project_type: splitList(openTalent.preferred_project_type),
    });
  };

  useEffect(() => {
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data || {};
      const openTalent = data?.open_talent || {};
      const normalizedExperiences = (data?.experiences || []).map((exp) => ({
        ...exp,
        start_date: normalizeDate(exp.start_date),
        end_date: normalizeDate(exp.end_date),
      }));
      setSavedData({
        experiences: normalizedExperiences,
        portfolio_links: openTalent?.sample_portfolio_link
          ? [openTalent.sample_portfolio_link]
          : [""],
        work_samples: parseArray(openTalent?.projects, []),
      });
    });
  }, [dispatch]);

  const handlePrevious = async () => {
    await refreshStep2FromProfile();
    dispatch(setRegisterStep("profileStep2"));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_4_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    Experience & Work Samples
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Add your experience and share your best work to stand out.
                  </p>
                </div>
                <Formik
                  initialValues={{
                    experiences:
                      savedData.experiences && savedData.experiences.length
                        ? savedData.experiences
                        : [emptyExperience],
                    portfolio_links:
                      savedData.portfolio_links && savedData.portfolio_links.length
                        ? savedData.portfolio_links
                        : [""],
                    work_samples: savedData.work_samples || [],
                  }}
                  validationSchema={profileStep3Schema}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    handleStep3(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <div className="col-md-12">
                          <h6 className="ct_fs_16 ct_darkblue_text mb-3">
                            Experience
                          </h6>
                          <FieldArray
                            name="experiences"
                            render={(arrayHelpers) => (
                              <div className="d-flex flex-column gap-4">
                                {values.experiences?.map((exp, idx) => (
                                  <div
                                    key={`experience-${idx}`}
                                    className="ct_outline_bg ct_border_radius_10 ct_p_20"
                                  >
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                      <p className="mb-0 ct_fs_14 ct_darkblue_text">
                                        Experience {idx + 1}
                                      </p>
                                      {values.experiences.length > 1 && (
                                        <button
                                          type="button"
                                          className="ct_yellow_btn ct_outline_grey py-1 px-3 ct_white_nowrap"
                                          style={{ minWidth: "90px" }}
                                          onClick={() => arrayHelpers.remove(idx)}
                                        >
                                          Remove
                                        </button>
                                      )}
                                    </div>
                                    <div className="row">
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Job Title
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="Job Title"
                                            name={`experiences.${idx}.job_title`}
                                            value={exp.job_title}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.job_title`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Company Name
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="Company Name"
                                            name={`experiences.${idx}.company_name`}
                                            value={exp.company_name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.company_name`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Start Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control ct_input"
                                            name={`experiences.${idx}.start_date`}
                                            value={exp.start_date}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.start_date`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            End Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control ct_input"
                                            name={`experiences.${idx}.end_date`}
                                            value={exp.end_date}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={exp.currently_working}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.end_date`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-3">
                                          <label className="ct_checkbox_label d-flex gap-2">
                                            <input
                                              type="checkbox"
                                              name={`experiences.${idx}.currently_working`}
                                              checked={exp.currently_working}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  `experiences.${idx}.currently_working`,
                                                  e.target.checked
                                                );
                                                if (e.target.checked) {
                                                  setFieldValue(
                                                    `experiences.${idx}.end_date`,
                                                    ""
                                                  );
                                                }
                                              }}
                                            />
                                            <span className="ct_fs_14 ct_darkblue_text">
                                              Currently working here
                                            </span>
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Work Experience
                                          </label>
                                          <textarea
                                            className="form-control ct_input h-auto"
                                            rows={4}
                                            placeholder="Work Experience"
                                            name={`experiences.${idx}.job_description`}
                                            value={exp.job_description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.job_description`}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-12">
                                        <div className="form-group mb-4">
                                          <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                                            Link (Optional)
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ct_input"
                                            placeholder="https://"
                                            name={`experiences.${idx}.link`}
                                            value={exp.link}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <ErrorMessage
                                            errors={errors}
                                            touched={touched}
                                            fieldName={`experiences.${idx}.link`}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="ct_yellow_btn ct_outline_grey py-2"
                                  onClick={() => arrayHelpers.push(emptyExperience)}
                                >
                                  Add Experience
                                </button>
                              </div>
                            )}
                          />
                        </div>

                        <div className="col-md-12 ct_mt_30">
                          <h6 className="ct_fs_16 ct_darkblue_text mb-3">
                            Work Samples
                          </h6>
                          <div className="form-group mb-4">
                            <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Portfolio Links / Case Studies
                            </label>
                            <FieldArray
                              name="portfolio_links"
                              render={(arrayHelpers) => (
                                <div className="d-flex flex-column gap-2">
                                  {values.portfolio_links?.map((link, idx) => (
                                    <div key={`portfolio-link-${idx}`} className="d-flex align-items-center gap-2">
                                      <input
                                        type="text"
                                        className="form-control ct_input"
                                        placeholder="https://"
                                        name={`portfolio_links.${idx}`}
                                        value={link}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      {values.portfolio_links.length > 1 && (
                                        <button
                                          type="button"
                                          className="ct_yellow_btn ct_outline_grey py-1 px-3 ct_white_nowrap"
                                          style={{ minWidth: "90px" }}
                                          onClick={() => arrayHelpers.remove(idx)}
                                        >
                                          Remove
                                        </button>
                                      )}
                                      <ErrorMessage
                                        errors={errors}
                                        touched={touched}
                                        fieldName={`portfolio_links.${idx}`}
                                      />
                                    </div>
                                  ))}
                                  <button
                                    type="button"
                                    className="ct_yellow_btn ct_outline_grey py-2"
                                    onClick={() => arrayHelpers.push("")}
                                  >
                                    Add Link
                                  </button>
                                </div>
                              )}
                            />
                          </div>
                          <div className="form-group mb-4">
                            <label className="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Upload Work Samples (Optional)
                            </label>
                            <PdfOrImageUploader
                              maxFiles={10}
                              multiple={true}
                              acceptType="application/pdf,image/*"
                              placeholder="Upload Work Samples"
                              existingFiles={
                                values?.work_samples && Array.isArray(values.work_samples)
                                  ? values.work_samples.map((file, idx) => {
                                    const isString = typeof file === "string";
                                    return {
                                      id: idx,
                                      file: isString
                                        ? file
                                        : file.preview
                                          ? file.preview
                                          : URL.createObjectURL(file),
                                      name: file.name || `work-sample-${idx}`,
                                      type: isString
                                        ? file.endsWith(".pdf")
                                          ? "pdf"
                                          : "image"
                                        : file.type?.includes("pdf")
                                          ? "pdf"
                                          : "image",
                                      preview: file.preview || null,
                                      isExisting: true,
                                    };
                                  })
                                  : []
                              }
                              onChange={(newFiles) => {
                                setTouched({ work_samples: true });
                                setFieldValue("work_samples", newFiles);
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="work_samples"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="d-flex gap-2 mt-2">
                        <button
                          type="button"
                          class="ct_outline_btn w-100 mx-auto"
                          onClick={handlePrevious}
                        >
                          Previous
                        </button>
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={3} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep3;
